import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { TrafficsDtoKeysEnum } from '@zaoblako/shared/modules/traffic/enums/traffics-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { SensorTypeEnum } from '@zaoblako/shared/modules/traffic/enums/sensor.type.enum';
import { SensorTypeEnumI18n } from '@zaoblako/shared/modules/traffic/i18n/sensor-type-enum.i18n';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';
import type { AdapterFindInterface } from '@zaoblako/shared/modules/traffic/dtos/adapter/adapter-find.dto';

import * as yup from 'yup';

/** Sensor create/update request body */
export interface SensorFormInterface {
  id?: number;
  /** Sensor display name */
  name: string;
  /** Sensor type */
  type: SensorTypeEnum;
  /** Sensor adapter */
  adapter: AdapterFindInterface;
}

/** Sensor create/update request body - DTO schema */
export const SensorFormDto = SerdeDtoClass.create<SensorFormInterface>(TrafficsDtoKeysEnum.SENSOR_FORM_DTO, {
  id: {
    optional: true,
    label: 'Номер',
    serializer: yup.number(),
  },
  name: {
    label: 'Название',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  type: {
    label: 'Тип',
    serializer: commonEnumValidator(SensorTypeEnum, SensorTypeEnumI18n),
  },
  adapter: {
    label: 'Адаптер',
    serializer: entityLikeSchema,
  },
});
